import { ApolloClient, InMemoryCache } from "@apollo/client";

export const ApplicationName = "radium v4";

const _api = process.env.REACT_APP_API_ENDPOINT || "/api/";
const _print = process.env.REACT_APP_ASSET_ENDPOINT || "/print/";

const api_url = _api.endsWith("/") ? _api : _api + "/";

const graphql_url = api_url + "graphql/";
export const print_url = _print.endsWith("/") ? _print : _print + "/";

console.log("api", {
  api_url,
  graphql_url,
  print_url,
});

export const apolloClient = new ApolloClient({
  uri: graphql_url,
  cache: new InMemoryCache(),
  credentials: "include",
  defaultOptions: {
    query: {
      fetchPolicy: "network-only",
    },
  },
});
